import React from 'react';
import { IonIcon } from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper';
import './flower.css';
import ProjectCard from './ProjectCard';

SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

const projects = [
  {
    image: 'path_to_your_image/img_1.jpg',
    title: 'Project 1',
    description: 'This is a description of Project 1.',
    link: 'https://example.com/project1'
  },
  {
    image: 'path_to_your_image/img_2.jpg',
    title: 'Project 2',
    description: 'This is a description of Project 2.',
    link: 'https://example.com/project2'
  },
  {
    image: 'path_to_your_image/img_3.jpg',
    title: 'Project 3',
    description: 'This is a description of Project 3.',
    link: 'https://example.com/project3'
  },
  {
    image: 'path_to_your_image/img_4.jpg',
    title: 'Project 4',
    description: 'This is a description of Project 4.',
    link: 'https://example.com/project4'
  },
  {
    image: 'path_to_your_image/img_5.jpg',
    title: 'Project 5',
    description: 'This is a description of Project 5.',
    link: 'https://example.com/project5'
  },
  {
    image: 'path_to_your_image/img_6.jpg',
    title: 'Project 6',
    description: 'This is a description of Project 6.',
    link: 'https://example.com/project6'
  },
  {
    image: 'path_to_your_image/img_7.jpg',
    title: 'Project 7',
    description: 'This is a description of Project 7.',
    link: 'https://example.com/project7'
  }
];

function Flower() {
  return (
    <div className="container">
      <h1 className="heading">Portfolio</h1>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true,
        }}
        className="swiper_container"
      >
        {projects.map((project, index) => (
          <SwiperSlide key={index}>
            <ProjectCard
              image={project.image}
              title={project.title}
              description={project.description}
              link={project.link}
            />
          </SwiperSlide>
        ))}

        <div className="slider-controler">
          <div className="swiper-button-prev slider-arrow">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </div>
          <div className="swiper-button-next slider-arrow">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </Swiper>
    </div>
  );
}

export default Flower;

// import React from 'react';
// // import { Swiper, SwiperSlide } from 'swiper/react';
// import { Swiper, SwiperSlide } from 'swiper/react';

// // import 'swiper/css';
// // import 'swiper/swiper.min.css';
// import 'swiper/swiper-bundle.css';
// // import 'swiper/css/effect-coverflow';
// import 'swiper/components/effect-coverflow';
// // import 'swiper/css/pagination';
// import 'swiper/components/pagination'
// // import 'swiper/css/navigation';
// import 'swiper/components/navigation';
// import './flower.css';

// import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper';

// import slide_image_1 from '../images/img_1.jpg';
// import slide_image_2 from '../images/img_2.jpg';
// import slide_image_3 from '../images/img_3.jpg';
// import slide_image_4 from '../images/img_4.jpg';
// import slide_image_5 from '../images/img_5.jpg';
// import slide_image_6 from '../images/img_6.jpg';
// import slide_image_7 from '../images/img_7.jpg';

// // Install Swiper modules
// SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

// function Flower() {
//   return (
//     <div className="container">
//       <h1 className="heading">Flower Gallery</h1>
//       <Swiper
//         effect={'coverflow'}
//         grabCursor={true}
//         centeredSlides={true}
//         loop={true}
//         slidesPerView={'auto'}
//         coverflowEffect={{
//           rotate: 0,
//           stretch: 0,
//           depth: 100,
//           modifier: 2.5,
//         }}
//         pagination={{ el: '.swiper-pagination', clickable: true }}
//         navigation={{
//           nextEl: '.swiper-button-next',
//           prevEl: '.swiper-button-prev',
//           clickable: true,
//         }}
//         className="swiper_container"
//       >
//         <SwiperSlide>
//           <img src={slide_image_1} alt="slide_image" />
//         </SwiperSlide>
//         <SwiperSlide>
//           <img src={slide_image_2} alt="slide_image" />
//         </SwiperSlide>
//         <SwiperSlide>
//           <img src={slide_image_3} alt="slide_image" />
//         </SwiperSlide>
//         <SwiperSlide>
//           <img src={slide_image_4} alt="slide_image" />
//         </SwiperSlide>
//         <SwiperSlide>
//           <img src={slide_image_5} alt="slide_image" />
//         </SwiperSlide>
//         <SwiperSlide>
//           <img src={slide_image_6} alt="slide_image" />
//         </SwiperSlide>
//         <SwiperSlide>
//           <img src={slide_image_7} alt="slide_image" />
//         </SwiperSlide>

//         <div className="slider-controler">
//           <div className="swiper-button-prev slider-arrow">
//             <ion-icon name="arrow-back-outline"></ion-icon>

//           </div>
//           <div className="swiper-button-next slider-arrow">
//             {/* <ion-icon name="dist/collection/components/icon/svg/arrow-forward-outline"></ion-icon> */}
//             <img height = "10px" width = "5px" src={slide_image_5} alt="slide_image" />
//           </div>
//           <div className="swiper-pagination"></div>
//         </div>
//       </Swiper>
//     </div>
//   );
// }

// export default Flower;

